import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { fetchMultipleSamplesInfoBig, fetchMultipleSamplesMetaInfo, fetchAggregateTaxa, fetchAggregateTaxaRank } from '../components/api';
// import TopAbundanceFromRank from '../utils/topAbundanecFromRank';
import SortedAbundanceFromRank from '../utils/sortedAbundanecFromRank';
import AverageCountForOverlappingTaxon from '../utils/averageCountForOverlappingTaxon';
import Loading from '../components/loading';
import BarChartTaxa from "../components/widgets/barChartTaxa"
import Dropdown from '../components/widgets/dropdown';
import FoldChangeBarChart from "../components/widgets/foldChangeBarChart"


function SubSample() {

    const divCenteredeInfoStyle = {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        // justifyContent: 'center',
        // alignItems: 'center',
        flexDirection: 'column',
        height: '100vh',
        // margin: top right bottom left
        margin: '50px 60px 20px 60px',
        overflowX: 'hidden',
        overflowY: 'auto',
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        borderRadius: '10px',
    };

    // divInner should start in the top left corner of the parent div
    const divInner = {
        // padding: '40px',
        padding: '0px 40px',
    }

    const h1Style = {
        color: 'white',
        fontSize: '30px'
    }

    const pStyle = {
        color: 'white',
        fontSize: '20px'
    }

    const [subSampleMetaData, setSubSampleMetaData] = useState(null);
    const [subSampleTaxaData, setSubSampleTaxaData] = useState(null);
    const [simpleFetchThreshold, setSimpleFetchThreshold] = useState(10)
    const [rank, setRank] = useState("g")
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [chartData, setChartData] = useState(null);
    const [averageTaxa, setAverageTaxa] = useState(null);
    const [subSampleAverageTaxa, setSubSampleAverageTaxa] = useState(null);
    const [foldChangeData, setFoldChangeData] = useState(null);

    const location = useLocation();
    const selectedSamples = location.state?.selectedSamples || [];

    const fetchSubSampleData = async (selectedSamples) => {
        const subSampleIds = selectedSamples.flat();
        if (selectedSamples.length <= simpleFetchThreshold) {
            try {
                const subSampleData = await fetchMultipleSamplesInfoBig(subSampleIds)

                // let dictionary = Object.fromEntries(data.map(x => [x.id, x.country]));
                let metaData = Object.assign({}, ...subSampleData.map((sample) => (
                    { [sample.run_assembly_id]: sample.meta_data })));

                // console.log(metaData)
                let taxaData = Object.assign({}, ...subSampleData.map((sample) => (
                    { [sample.run_assembly_id]: sample.taxonomic_data })));
                // console.log(taxaData)

                setSubSampleMetaData(metaData)
                setSubSampleTaxaData(taxaData)

                setLoading(false)
            } catch (err) {
                setError('failed to fetch sample data');
            }
        } else {
            try {
                const subSampleData = await fetchMultipleSamplesMetaInfo(subSampleIds)
                let metaData = Object.assign({}, ...subSampleData.map((sample) => (
                    { [sample.run_assembly_id]: sample.meta_data })));
                // console.log(subSampleData)
                setSubSampleMetaData(metaData)
                setLoading(false)
            } catch (err) {
                setError('failed to fetch sample data');
            }
        }

    };

    useEffect(() => {
        fetchSubSampleData(selectedSamples);
    }, [selectedSamples]);

    useEffect(() => {
        if (subSampleTaxaData && selectedSamples.length > 0 && selectedSamples.length <= simpleFetchThreshold) {
            // const rank = "g";
            const top = 10;
            const topXOrgAbundance = SortedAbundanceFromRank({ subSampleTaxaData, rank, top })
            setChartData(topXOrgAbundance);

            // calculate average taxon count for overlapping samples taxon
            // console.log("subSampleTaxaData:", subSampleTaxaData);

            const avgCountTaxa = AverageCountForOverlappingTaxon({ subSampleTaxaData, rank })
            // console.log("filtered by rank:", filteredByRank);
            // console.log("avgCount:", avgCountTaxa);
            setSubSampleAverageTaxa(avgCountTaxa);
        }
    }, [subSampleTaxaData, selectedSamples, rank]);

    // can be changed to only show taxa of a given rank 
    const fetchAverageTaxa = async (rank) => {
        const totalSample = 15000; // this should not be hardcoded
        // const totalTaxa = await fetchAggregateTaxa()
        const totalTaxa = await fetchAggregateTaxaRank(rank)
        totalTaxa.forEach(item => {
            item.count = parseInt(item.total_count);
            item.averageCountTotal = item.total_count / totalSample;
        });
        // console.log(totalTaxa);
        // let avgData = Object.assign({}, ...subSampleData.map((sample) => (
        //     { [sample.run_assembly_id]: sample.taxonomic_data })));
        setAverageTaxa(totalTaxa)
    }


    useEffect(() => {
        fetchAverageTaxa(rank)

    }, [rank, subSampleAverageTaxa]);

    useEffect(() => {
        if (subSampleAverageTaxa && averageTaxa) {
            console.log("subSampleAverageTaxa:", subSampleAverageTaxa);
            console.log("averageTaxa:", averageTaxa);
            const log2fc = subSampleAverageTaxa.map((item) => {
                // console.log(item);

                const avgItem = averageTaxa.find((avgItem) => avgItem.name === item.name);
                // console.log(avgItem.total_count);
                // console.log(content);
                if (avgItem) {
                    item.log2fc = Math.log2(item.avgCount / avgItem.averageCountTotal);
                    item.totalAvgCount = avgItem.averageCountTotal;
                }
                // console.log(item);
                return item;
            });
            const sortedData = log2fc
                .filter(d => d.log2fc !== null)
                .sort((a, b) => a.log2fc - b.log2fc);
            console.log("sortedData log2fc:", sortedData);
            setFoldChangeData(sortedData);
        }
    }, [subSampleAverageTaxa, averageTaxa]);

    if (loading || !subSampleMetaData || selectedSamples.length === 0) {
        return <Loading />;
    }
    if (error) {
        return <div>{error}</div>;
    }

    const handleRankSelection = (item) => {
        const rankDict = { 'phylum': 'p', 'class': 'c', 'order': 'o', 'family': 'f', 'genus': 'g', 'species': 's' };
        setRank(rankDict[item]);
    };



    if (selectedSamples.length <= simpleFetchThreshold) {
        // console.log(subSampleTaxaData[0])
        return (
            <div style={divCenteredeInfoStyle}>
                <div style={divInner}>
                    <h1>SubSample Information</h1>
                    {/* <p>Number of samples: {selectedSamples.length}</p> */}
                    <p>show broad information</p>
                    <Dropdown
                        items={['phylum', 'class', 'order', 'family', 'genus', 'species']}
                        onSelect={handleRankSelection}
                        placeholder="Select Rank"
                    />
                    <p>{selectedSamples.length} samples selected</p>

                    {chartData && <BarChartTaxa data={chartData} />}
                    {/* {foldChangeData && <FoldChangeBarChart data={foldChangeData} />} */}
                    <FoldChangeBarChart foldChangeData={foldChangeData} />
                    {/* {} */}


                    {/* download cumulative OTU's */}
                    {/* <p>{subSampleTaxaData}</p> */}

                    <Link to="/">Back to Home</Link>
                </div>
            </div>
        );
    } else {
        return (
            <div>
                <h1>SubSample Information</h1>
                <p>show simple information</p>
                <p>{selectedSamples.length} samples selected</p>

                <Link to="/">Back to Home</Link>
            </div>
        );
    }
}

export default SubSample;